module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"monthly-icome":"Faturamento mensal"},"en-US":{"monthly-icome":"Monthly income"}}')
  delete Component.options._Ctor
}
